import { TApplicationState } from '../../types/redux';
import { selectFormFields } from '../formFields';

export const selectFlatFormValues = (state: TApplicationState) => {
  const formFields = selectFormFields(state);

  return {
    roomsCount: formFields.roomsCount as number,
    houseId: formFields.houseId as number,
    area: formFields.area as number,
    flatNumber: formFields.flatNumber ? String(formFields.flatNumber) : undefined,
  };
};
